export default __webpack_public_path__ + "static/media/5.96dea6fc.png";